module.exports = __webpack_public_path__ + "img/avatar_29.ba3c4769.svg";